import { render, staticRenderFns } from "./SummaryStatPanel.vue?vue&type=template&id=517675e8"
import script from "./SummaryStatPanel.vue?vue&type=script&lang=js"
export * from "./SummaryStatPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports